module.exports = __webpack_public_path__ + "static/media/icon top.3884f11d.svg";